import React, { useState } from 'react'
import { Button, Tooltip } from '@mui/material'
import { GroupType, ProductType } from '../../resources/products/types'
import { GroupSelection } from './GroupSelection'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  allProductsById,
  groupsByProductId,
  productTocAtom,
} from '../../../api/masters.atoms'
import { Table } from 'shared/ui/Table/Table'

export function ProductSelection({
  onSelect,
  selectedProductId,
}: {
  onSelect(p: { id: number }): void
  selectedProductId?: number
}) {
  const [selectedGroup, setSelectedGroup] = useState<GroupType | undefined>(
    undefined,
  )
  const [selectingProduct, setSelectingProduct] = useState(false)
  const allGroups = useAtomValue(groupsByProductId)

  const onGroupSelect = (g?: GroupType) => {
    setSelectedGroup(g)
    setSelectingProduct(true)
  }

  const group =
    selectedGroup ||
    (selectedProductId && allGroups[selectedProductId]) ||
    undefined
  if (!group || !selectingProduct)
    return (
      <GroupSelection onSelect={onGroupSelect} selectedGroupId={group?.id} />
    )

  return (
    <ProductSelect
      group={group}
      onCancel={() => setSelectingProduct(false)}
      onSelect={onSelect}
      selectedProductId={selectedProductId}
    />
  )
}

function ProductSelect({
  group,
  onCancel,
  onSelect,
  selectedProductId,
}: {
  group: GroupType
  onCancel(): void
  onSelect(p: ProductType): void
  selectedProductId?: number
}) {
  const allProducts = useAtomValue(allProductsById)
  const { grouped } = useAtomValue(productTocAtom)
  const selectGroup = grouped[group.id]

  const columns = [
    {
      title: '',
      width: 100,
      rowContent(id: number) {
        const { title } = allProducts[id]
        if (id === selectedProductId) {
          return <strong>{title}</strong>
        }
        return (
          <Tooltip title={title} enterDelay={500} placement="right">
            <span>{title}</span>
          </Tooltip>
        )
      },
    },
  ]
  const selectedIndex = (index: number) => {
    const productId = selectGroup[index]
    onSelect(allProducts[productId])
  }
  return (
    <Table
      title={group?.name ?? 'Select Product'}
      items={selectGroup}
      columns={columns}
      onRowClick={selectedIndex}
      toolBarItems={[
        <Button key="cancel" onClick={onCancel}>
          Back
        </Button>,
      ]}
    />
  )
}
